module.exports = __webpack_public_path__ + "static/media/ico_calendar.c7135f08.svg";